module.exports = __webpack_public_path__ + "img/delete.6e830709.svg";